import { render, staticRenderFns } from "./CheckoutPaymentWari.vue?vue&type=template&id=51f90820&scoped=true&"
import script from "./CheckoutPaymentWari.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentWari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f90820",
  null
  
)

export default component.exports